export interface GetDetailRecordsPayload {
  invoiceNumber: string;
  serviceNo: string;
  serviceId: number;
  ebillSection?: string;
  ebillGroup?: string;
  ebillOrigNo?: string;
  ebillTermNo?: string;
  ebillOrderBy?: string;
  summaryGroupCode?: string;
  summaryChargeCode?: string;
  posNext?: number;
  pageSize?: number;
}
export const filterPayload = (payload: GetDetailRecordsPayload) => {
  return {
    invoiceNumber: payload.invoiceNumber,
    serviceNo: payload.serviceNo,
    serviceId: payload.serviceId,
    ebillSection: payload.ebillSection === '-' || payload.ebillSection === '' ? undefined : payload.ebillSection,
    ebillGroup: payload.ebillGroup === '-' || payload.ebillGroup === '' ? undefined : payload.ebillGroup,
    ebillOrigNo: payload.ebillOrigNo === '-' || payload.ebillOrigNo === '' ? undefined : payload.ebillOrigNo,
    ebillTermNo: payload.ebillTermNo === '-' ? undefined : payload.ebillTermNo,
    ebillOrderBy: payload.ebillOrderBy,
    summaryGroupCode: payload.summaryGroupCode,
    summaryChargeCode: payload.summaryChargeCode,
    posNext: payload.posNext,
    pageSize: payload.pageSize,
  };
};
